module.exports = __webpack_public_path__ + "img/vac-h.9433a79b.svg";